import clsx from "classnames";
import { trimText } from "@/functions/trimText";
import { Button } from "react-bootstrap";
import classes from "./styles.module.scss";

export const JobCard = ({ className, title, description, location, href, buttonVariant }) => {
  return (
    <div className={clsx(className, classes.card)}>
      <h5 dangerouslySetInnerHTML={{ __html: trimText(title, 36) }} />
      <div className="text-muted mb-3">{location}</div>
      <div className="flex-grow-1 mb-4" dangerouslySetInnerHTML={{ __html: trimText(description, 120) }} />
      <div>
        <Button variant={buttonVariant} href={href}>
          View Job
        </Button>
      </div>
    </div>
  );
};

JobCard.defaultProps = {
  buttonVariant: "outline-blue",
};
